const state = {
  balance: null,
  trcAddress: null,
  trcAddressValidTo: 0,
  ercAddress: null,
  ercAddressValidTo: 0,
  trcV2Address: null,
  trcV2AddressValidTo: 0
};

const getters = {
  getUserBalance: state => {
    if (state.balance == null) {
      return localStorage.getItem("user_balance");
    }
    return state.balance;
  },
  getTRC20Address: state => {
    if (state.trcAddress == null || state.trcAddress == 0 || state.trcAddressValidTo == 0) { 
      return {
        address: localStorage.getItem("trc20addr"),
        validTo: localStorage.getItem("trc20addrValid")  
      }; 
    }
    return {
      address: state.trcAddress,
      validTo: state.trcAddressValidTo
    }; 
  },
  getERC20Address: state => {
    if (state.ercAddress == null || state.ercAddress == 0 || state.ercAddressValidTo == 0) {
      return {
        address: localStorage.getItem("erc20addr"),
        validTo: localStorage.getItem("erc20addrValid")
      };
    }
    return {
      address: state.ercAddress,
      validTo: state.ercAddressValidTo
    };
  },
  getTRC20V2Address: state => {
    if (state.trcV2Address == null || state.trcV2Address == 0 || state.trcV2AddressValidTo == 0) {
      return {
        address: localStorage.getItem("trc20v2addr"),
        validTo: localStorage.getItem("trc20v2addrValid")
      };
    }
    return {
      address: state.trcV2Address,
      validTo: state.trcV2AddressValidTo
    };
  }
};

const mutations = {
  changeUserBalance: (state, newItem) => {
    localStorage.setItem("user_balance", newItem);
    state.balance = newItem;
  },
  setNewTRC20Address: (state, address) => {
    localStorage.setItem("trc20addr", address.address);
    localStorage.setItem("trc20addrValid", address.validTo);
    state.trcAddress = address.address;
    state.trcAddressValidTo = address.validTo;
  },
  setNewERC20Address: (state, address) => {
    localStorage.setItem("erc20addr", address.address);
    localStorage.setItem("erc20addrValid", address.validTo);
    state.ercAddress = address.address;
    state.ercAddressValidTo = address.validTo;
  },
  setNewTRC20V2Address: (state, address) => {
    localStorage.setItem("trc20v2addr", address.address);
    localStorage.setItem("trc20v2addrValid", address.validTo);
    state.trcV2Address = address.address;
    state.trcV2AddressValidTo = address.validTo;
  }
};

export default {
  state,
  getters,
  mutations
};


//////////////////
// WEBPACK FOOTER
// ./store/modules/user-details.js
// module id = null
// module chunks = 